import moment from 'moment';

export default {
    name: 'AddUser',
    created() {
        this.GetInfo();
    },
    components: {
       
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('MMMM Do YYYY');
        }
    },
    data() {
        return {
            state: 0,
            Info: [],

            list1:[],
            list2:[],
            list3:[],
            list4:[],
            list5:[],
            //Info1: [],
            
        };
    },
    methods: {
      

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            this.$blockUI.Start();
            this.$http.GetRequiment(this.pageNo, this.pageSize,)
                .then(response => {
                    this.$blockUI.Stop();
                    //this.Info = response.data.devices;
                    this.Info = response.data.filters;

                    this.list1 = this.Info.filter(function (element) { return element.company == 1; });
                    this.list2 = this.Info.filter(function (element) { return element.company == 2; });
                    this.list3 = this.Info.filter(function (element) { return element.company == 3; });
                    this.list4 = this.Info.filter(function (element) { return element.company == 4; });
                    this.list5 = this.Info.filter(function (element) { return element.company == 5; });
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.pages = 0;
                });

        },


        

    }
}
